
import React, { useState } from 'react';
import { mockSmartGasMeters } from '@/lib/mock-data/gas/smart-meters';
import { mockIoTGateways } from '@/lib/mock-data/gas/gateways';
import DeviceSearchBar from '@/components/device-health/DeviceSearchBar';
import DeviceHealthTabs from '@/components/device-health/DeviceHealthTabs';
import { getAllGasSmartMeters } from './device-health/utils/deviceMappingUtils';

const GasDeviceHealthDashboard = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedDevice, setSelectedDevice] = useState<{ id: string; type: 'smartMeter' | 'gateway' } | null>(null);
  
  // Get all smart meters including those mapped from GIS
  const allSmartMeters = getAllGasSmartMeters(mockSmartGasMeters);
  
  // Filter smart meters and gateways based on search query
  const filteredSmartMeters = allSmartMeters.filter(meter => 
    meter.deviceId.toLowerCase().includes(searchQuery.toLowerCase()) || 
    meter.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
    meter.status.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  const filteredGateways = mockIoTGateways.filter(gateway => 
    gateway.deviceId.toLowerCase().includes(searchQuery.toLowerCase()) || 
    gateway.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
    gateway.status.toLowerCase().includes(searchQuery.toLowerCase())
  );
  
  // Handle device selection
  const handleDeviceSelect = (deviceId: string, deviceType: 'smartMeter' | 'gateway') => {
    setSelectedDevice({ id: deviceId, type: deviceType });
  };

  return (
    <div className="w-full h-full flex flex-col pt-4 overflow-hidden">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-2 mb-2 sm:mb-4 flex-shrink-0 px-4">
        <h2 className="text-lg sm:text-xl font-semibold text-gray-800 dark:text-white">Gas Device Health</h2>
        <DeviceSearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
      </div>
      
      <div className="w-full flex-grow overflow-auto border-t border-gray-100 dark:border-gray-800">
        <DeviceHealthTabs 
          smartMeters={filteredSmartMeters}
          gateways={filteredGateways}
          selectedDevice={selectedDevice}
          onSelectDevice={handleDeviceSelect}
          deviceType="gas"
        />
      </div>
    </div>
  );
};

export default GasDeviceHealthDashboard;
